import { gql } from '@apollo/client';

const GET_DOCUMENTS_QUERY = gql`
  query GetDocuments($ownerId: String!) {
    documents(ownerId: $ownerId) {
      documents {
        name
        id
        type
        ownerId
        uploaded
      }
    }
  }
`;

const GET_DOCUMENT_CONTENT_QUERY = gql`
  query GetDocumentContent($docId: UUID!) {
    getDocumentContent(docId: $docId) {
      id
      ownerId
      name
      type
      uploaded
      url
    }
  }
`;

export const documentUploadQueries = {
  GET_DOCUMENTS_QUERY,
  GET_DOCUMENT_CONTENT_QUERY,
};
